import React from 'react';

const IconProps = {
  width: '1em',
  height: '1em',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};

export function LayoutPedoFMX(props) {
  return (
    <svg {...IconProps} {...props}>
      <path d="M2 4h3v6H2zM5.5 4h3v6h-3zM9 4h3v6H9zM12.5 4h3v6h-3zM16 4h3v6h-3zM19.5 4h3v6h-3z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 12h3v6H8zM13 12h3v6h-3z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M4 20h3.5v-6H4zM8 20h3.5v-6H8zM12 20h3.5v-6h-3.5zM16 20h3.5v-6H16z" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

export function LayoutUPDNPA(props) {
  return (
    <svg {...IconProps} {...props}>
      <rect x="8" y="2" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="8" y="9" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="8" y="16" width="8" height="6" rx="1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

export function Layout4Bitewing(props) {
  return (
    <svg {...IconProps} {...props}>
      <rect x="2" y="3" width="9" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="13" y="3" width="9" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="2" y="13" width="9" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="13" y="13" width="9" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

export function Layout2Bitewing(props) {
  return (
    <svg {...IconProps} {...props}>
      <rect x="2" y="7" width="9" height="10" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="13" y="7" width="9" height="10" rx="1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

export function Layout4BW2PA(props) {
  return (
    <svg {...IconProps} {...props}>
      <rect x="2" y="2" width="9" height="6" rx="0.5" stroke="currentColor" strokeWidth="1.5" />
      <rect x="13" y="2" width="9" height="6" rx="0.5" stroke="currentColor" strokeWidth="1.5" />
      <rect x="2" y="9" width="9" height="6" rx="0.5" stroke="currentColor" strokeWidth="1.5" />
      <rect x="13" y="9" width="9" height="6" rx="0.5" stroke="currentColor" strokeWidth="1.5" />
      <rect x="7" y="16" width="10" height="6" rx="0.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

export function LayoutFMX18(props) {
  return (
    <svg {...IconProps} {...props}>
      {/* Upper 8 */}
      <rect x="1" y="2" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="3.8" y="2" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="6.6" y="2" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="9.4" y="2" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="12.2" y="2" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="15" y="2" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="17.8" y="2" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="20.6" y="2" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />

      {/* Middle 4 */}
      <rect x="5" y="9" width="3" height="5" stroke="currentColor" strokeWidth="1" />
      <rect x="8.5" y="9" width="3" height="5" stroke="currentColor" strokeWidth="1" />
      <rect x="12.5" y="9" width="3" height="5" stroke="currentColor" strokeWidth="1" />
      <rect x="16" y="9" width="3" height="5" stroke="currentColor" strokeWidth="1" />

      {/* Lower 6 */}
      <rect x="3.8" y="15" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="6.6" y="15" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="9.4" y="15" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="12.2" y="15" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="15" y="15" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
      <rect x="17.8" y="15" width="2.5" height="6" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}

export function LayoutFMX20(props) {
  return (
    <svg {...IconProps} {...props}>
      <path d="M2 2h2v5H2zM4.5 2h2v5h-2zM7 2h2v5H7zM9.5 2h2v5h-2zM12.5 2h2v5h-2zM15 2h2v5H15zM17.5 2h2v5h-2zM20 2h2v5H20z" stroke="currentColor" strokeWidth="1" />
      <path d="M2 9h4v5H2zM18 9h4v5h-4z" stroke="currentColor" strokeWidth="1" />
      <path d="M2 16h2v5H2zM4.5 16h2v5h-2zM7 16h2v5H7zM9.5 16h2v5h-2zM12.5 16h2v5h-2zM15 16h2v5H15zM17.5 16h2v5h-2zM20 16h2v5H20z" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}

export function LayoutFMX21(props) {
  return (
    <svg {...IconProps} {...props}>
      <path d="M2 2h2v5H2zM4.5 2h2v5h-2zM7 2h2v5H7zM9.5 2h2v5h-2zM12.5 2h2v5h-2zM15 2h2v5H15zM17.5 2h2v5h-2zM20 2h2v5H20z" stroke="currentColor" strokeWidth="1" />
      <path d="M2 9h3v5H2zM5.5 9h3v5h-3zM15.5 9h3v5h-3zM19 9h3v5h-3z" stroke="currentColor" strokeWidth="1" />
      <path d="M2 16h2v5H2zM4.5 16h2v5h-2zM7 16h2v5H7zM9.5 16h2v5h-2zM12.5 16h2v5h-2zM15 16h2v5H15zM17.5 16h2v5h-2zM20 16h2v5H20z" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}

export function LayoutGrid(props) {
  return (
    <svg {...IconProps} {...props}>
      <rect x="3" y="3" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="13" y="3" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="3" y="13" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="13" y="13" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}
